var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0,2.85v11.4L5.25,11.4l6,2.85L16.5,11.4V0L11.25,2.85,5.25,0Z",
  transform: "translate(0.75 2.25)",
  fill: "none",
  stroke: "#344da6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M0,0V11.25",
  transform: "translate(6 2.25)",
  fill: "none",
  stroke: "#344da6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Shape",
  d: "M0,0V11.25",
  transform: "translate(12 5.25)",
  fill: "none",
  stroke: "#344da6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M0,0H18V18H0Z",
  fill: "none"
});
var SvgScopeIcon = function SvgScopeIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "feather-icon / map",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScopeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Scope-icon.b9c532db.svg";
export { ForwardRef as ReactComponent };